/**
 * TanStack Query hooks for `third-party-fraud-integrations-mfilterit-fraudscor`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	thirdPartyFraudIntegrationsMfilteritFraudscorQueryKeys,
	type CreateThirdPartyFraudIntegrationsMfilteritFraudscorBody,
	type ListThirdPartyFraudIntegrationsMfilteritFraudscorResponse,
	type ThirdPartyFraudIntegrationsMfilteritFraudscorRow,
} from "./api";

export function useThirdPartyFraudIntegrationsMfilteritFraudscorList(): UseQueryResult<ListThirdPartyFraudIntegrationsMfilteritFraudscorResponse, Error> {
	return useQuery({
		queryKey: thirdPartyFraudIntegrationsMfilteritFraudscorQueryKeys.list(),
		queryFn: list,
	});
}

export function useThirdPartyFraudIntegrationsMfilteritFraudscorCreate(): UseMutationResult<ThirdPartyFraudIntegrationsMfilteritFraudscorRow, Error, CreateThirdPartyFraudIntegrationsMfilteritFraudscorBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: thirdPartyFraudIntegrationsMfilteritFraudscorQueryKeys.all });
		},
	});
}

export function useThirdPartyFraudIntegrationsMfilteritFraudscorDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: thirdPartyFraudIntegrationsMfilteritFraudscorQueryKeys.all });
		},
	});
}
